import { render, staticRenderFns } from "./BoostingPageAvatars.vue?vue&type=template&id=235c590a&scoped=true&"
import script from "./BoostingPageAvatars.vue?vue&type=script&lang=js&"
export * from "./BoostingPageAvatars.vue?vue&type=script&lang=js&"
import style0 from "./BoostingPageAvatars.vue?vue&type=style&index=0&id=235c590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c590a",
  null
  
)

export default component.exports